import cloneDeep from 'lodash-es/cloneDeep';
import { ThemeUICSSObject } from 'theme-ui';
import { TStatesRetriever } from '../types';
import getColorState from './getColorState';

/**
 * Este método está pensado para usarse únicamente dentro de applyStates, si se
 * desea obtener un objeto con las propiedades correspondientes a un estado,
 * utilizar el método getColorStates.
 */
const applyStatesGetColor: TStatesRetriever = (definition, palette, states) => {
  const newStates: ThemeUICSSObject =
    states?.default !== false
      ? cloneDeep(definition)
      : ({} as ThemeUICSSObject);

  if (states?.active !== false) {
    newStates.active = getColorState(definition, 'active', palette);
  }
  if (states?.disabled !== false) {
    newStates.disabled = getColorState(definition, 'disabled', palette);
  }
  if (states?.focus !== false) {
    newStates.focus = getColorState(definition, 'focus', palette);
  }
  if (states?.hover !== false) {
    newStates.hover = getColorState(definition, 'hover', palette);
  }
  if (states?.readonly !== false) {
    newStates.readonly = getColorState(definition, 'readonly', palette);
  }
  if (states?.selected !== false) {
    newStates.selected = getColorState(definition, 'selected', palette);
  }
  if (states?.checked !== false) {
    newStates.checked = getColorState(definition, 'checked', palette);
  }
  return newStates;
};

export default applyStatesGetColor;
